var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1 request_list",attrs:{"headers":_vm.requestHeaders,"items":_vm.requestList,"items-per-page":15,"loading":_vm.isLoading,"item-class":_vm.itemRowBackground},on:{"click:row":_vm.handleClick},scopedSlots:_vm._u([{key:"item.decision",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.decision[item.decision])+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }